import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { lazyInitializeLivePersonaCard, lazyPersonaControlStore } from '../lazyFunctions';
import { userInteractionAction } from 'owa-calendar-actions';
import { trace } from 'owa-trace';

export default async function editBirthdayEventMenuAction(event: CalendarEvent) {
    let personaControlStore = lazyPersonaControlStore.tryImportForRender();

    // This code exists to ensure that the live persona card is initialized
    if (!personaControlStore || !personaControlStore.isLivePersonaCardInitialized) {
        await initializeLivePersonaCardForBirthdayEvent();
        personaControlStore = lazyPersonaControlStore.tryImportForRender();
    }

    if (personaControlStore?.isLivePersonaCardInitialized) {
        const lpc = (window as any).LPC;
        if (!lpc) {
            return;
        }
        lpc.renderContactEditor(
            {
                olsPersonaId: event.PersonId.Id,
            },
            {
                onSave: () => {
                    userInteractionAction(
                        'EventEdited',
                        'EditForm',
                        event.IsOrganizer,
                        event.IsMeeting,
                        ['birthday']
                    );
                },
                onCancel: () => {
                    userInteractionAction(
                        'Discard',
                        'EditForm',
                        event.IsOrganizer,
                        event.IsMeeting,
                        ['birthday']
                    );
                },
            },
            {
                focusPropertyUri: 'PersonaBirthdays',
            }
        );
    }
}

const isLivePersonaCardInitialized = (): boolean => {
    let personaControlStore = lazyPersonaControlStore.tryImportForRender();
    return personaControlStore?.isLivePersonaCardInitialized;
};

const ensureLivePersonaCardIsInitialized = (interval: number, maxAttempts: number) => {
    let attempt: number = 0;
    return new Promise<void>(function (resolve, reject) {
        (function waitForInitialization() {
            attempt++;
            if (isLivePersonaCardInitialized()) {
                return resolve();
            } else if (attempt == maxAttempts) {
                return reject(
                    new Error('ensureLivePersonaCardIsInitialized max attempts exhausted')
                );
            }
            setTimeout(waitForInitialization, interval);
        })();
    }).catch(e => trace.warn(e.message));
};

export async function initializeLivePersonaCardForBirthdayEvent() {
    // This code exists to ensure that the live persona card is initialized
    await lazyInitializeLivePersonaCard
        .import()
        .then(initializeLivePersonaCard => initializeLivePersonaCard());

    // Polling to check if the persona card has been initialized before returning a promise.
    const pollInterval = 1000;
    const pollAttempts = 5;
    await ensureLivePersonaCardIsInitialized(pollInterval, pollAttempts);
}
